var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSmGrazing2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_718_1341)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2 15.31H24.222C24.2959 15.31 24.3669 15.3394 24.4192 15.3917C24.4716 15.444 24.501 15.515 24.501 15.589C24.501 15.663 24.4716 15.7339 24.4192 15.7863C24.3669 15.8386 24.2959 15.868 24.222 15.868H0.780953C0.706958 15.868 0.635993 15.8386 0.58367 15.7863C0.531348 15.7339 0.501953 15.663 0.501953 15.589C0.501953 15.515 0.531348 15.444 0.58367 15.3917C0.635993 15.3394 0.706958 15.31 0.780953 15.31H4.57095L4.11895 13.492C4.02295 13.107 4.18095 12.584 4.47495 12.322L4.68095 12.138L3.65395 8.57699V12.259H3.28895V7.75599H3.41695L11.709 7.52499C12.796 7.49499 14.138 8.23699 14.691 9.18399L16.604 12.459C16.7 12.623 16.796 12.837 16.876 13.059L16.829 12.759H17.794L17.015 13.507C17.04 13.606 17.06 13.7 17.072 13.784L17.246 14.951C17.2657 15.073 17.2494 15.1981 17.199 15.311L17.2 15.31ZM16.344 15.31C16.2597 15.2506 16.1829 15.1815 16.115 15.104L15.618 14.524C15.36 14.222 15.148 13.654 15.148 13.261V13.188L13.701 12.8L14.956 15.31H16.343H16.344ZM14.117 15.31L12.304 12.616H7.38895L7.02295 12.99C6.74195 13.277 6.18495 13.539 5.80295 13.572L5.09295 13.635L5.29795 15.31H6.74495L5.83995 13.742H5.84795C6.23795 13.712 6.73195 13.512 6.93295 13.295L7.55295 15.31H11.903L11.778 12.795H12.16L12.689 13.545L12.554 15.31H14.117ZM9.55695 18.1C9.48495 18.1 9.42695 17.975 9.42695 17.82C9.42695 17.667 9.48495 17.542 9.55695 17.542H20.455C20.526 17.542 20.585 17.667 20.585 17.821C20.585 17.975 20.526 18.1 20.455 18.1H9.55695ZM4.53595 16.984C4.46395 16.984 4.40595 16.859 4.40595 16.704C4.40595 16.551 4.46395 16.426 4.53595 16.426H15.434C15.505 16.426 15.564 16.551 15.564 16.705C15.564 16.859 15.505 16.984 15.434 16.984H4.53595Z",
    fill: "#36975C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_718_1341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSmGrazing2);
export default __webpack_public_path__ + "static/media/ic-sm-grazing-2.e37bf23056aead6ca108ae8fe1e05789.svg";
export { ForwardRef as ReactComponent };